<template>
  <div class="side-service">
    <div class="service-item service-consult">
      <div class="service-icon"><i class="fas fa-headset"></i></div>
      <div class="service-text">咨询</div>
    </div>
    <div class="service-item service-phone">
      <div class="service-icon"><i class="fas fa-phone"></i></div>
      <div class="service-text">电话咨询</div>
      <div class="service-popup">
        <div class="popup-content">
          <i class="fas fa-phone"></i>
          <span>4006-696-280</span>
        </div>
      </div>
    </div>
    <div class="service-item service-wechat">
      <div class="service-icon"><i class="fab fa-weixin"></i></div>
      <div class="service-text">扫码咨询</div>
      <div class="service-popup">
        <div class="popup-content">
          <img src="@/assets/images/gongzhonghao.jpg" alt="微信公众号">
        </div>
      </div>
    </div>
    <div class="service-item service-online">
      <div class="service-icon"><i class="fas fa-comments"></i></div>
      <div class="service-text">在线客服</div>
      <div class="service-popup">
        <div class="popup-content">
          <router-link to="/contact" target="_blank">点击立即咨询服务</router-link>
        </div>
      </div>
    </div>
    <div class="service-item service-trial">
      <div class="service-icon"><i class="fas fa-paper-plane"></i></div>
      <div class="service-text">免费试用</div>
      <div class="service-popup">
        <div class="popup-content">
          <a href="https://sdtz.guanjd.com/#/" target="_blank">点击立即免费试用</a>
        </div>
      </div>
    </div>
    <div class="service-item service-top" @click="scrollToTop">
      <div class="service-icon"><i class="fas fa-arrow-up"></i></div>
      <div class="service-text">返回顶部</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SideService',
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }
}
</script>